/* eslint-disable */
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useRef, useState, memo } from "react";

import { Button } from "react-bootstrap";
import { CircularProgress } from "@mui/material";

import { Link, useLocation } from "react-router-dom";

import { fabric } from "fabric";
import { toast } from "react-toastify";
import App from "../App";
import Fabricfile from "../Pages/Fabricfile";
import apiClient from "../api/apiClient";
import { handleErrors } from "../modules/handleErrors";
import { useSettings } from "../contextapi/SettingsContext";

import * as Yup from "yup";
import PsdCanvas from "../api/Editercomponents/PsdCanvas";
import { Add, Close, Delete } from "@mui/icons-material";
import { Loader } from "./Loader/loader";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ListingSelector from "./ListingSelectorModal";
import { sanitizeStepperPriceInput } from "./StepperSteps/utils/helpers";

export const BundleParentStepper = ({
  onHide,
  fetchBundleMockups,
  editlistdata,
  mocko_id,
  FeaturedMockups,
}) => {
  const { minimumPrice } = useSettings();
  const [fieldErrors, setFieldErrors] = useState({});
  const runValidations = (schema, data) => {
    try {
      schema.validateSync(data, { abortEarly: false });
      return { success: true };
    } catch (err) {
      const errorsObj = {};
      err.inner?.forEach((validationError) => {
        if (!errorsObj[validationError.path]) {
          errorsObj[validationError.path] = [];
        }
        errorsObj[validationError.path].push(validationError.message);
      });

      return { success: false, validationErrors: errorsObj };
    }
  };
  const [loader, setloader] = useState(false);
  const [stepperFormdata, setStepperFormdata] = useState({
    long_description: "",
    price: "",
    short_description: "",
    title: "",
    category: Yup.string().required("Category is required"),
    is_published: true,
    subcategory: "",
    subsubcategory: "",
    file: "",
    listings: [],
    listing_ids: [],
    bundle_thumbnails: [],
    category: [],
  });

  // Create validation schema dynamically using minimumPrice
  const validationSchema = [
    Yup.object({
      long_description: Yup.string().required("Long description is required"),
      short_description: Yup.string().required("Short description is required"),
      title: Yup.string().required("Title is required"),
      thumbnails: Yup.array()
        .min(1, "At least one thumbnail is required")
        .required("At least one thumbnail is required"),
    }),
  ];

  // Function to create paid validation schema with dynamic minimum price
  const createPaidValidationSchema = () => {
    return Yup.object({
      price: Yup.number()
        .min(minimumPrice, `Price must be at least ${minimumPrice}$`)
        .required("Price is required"),
      category: Yup.string().required("Category is required"),
    });
  };

  const handleChange = (key, value) => {
    setStepperFormdata((pre) => ({ ...pre, [key]: value }));
  };

  const [canvas, setCanvas] = useState(null);

  const [step, setStep] = useState(1);

  const nextStep = () => {
    // Ensure at least one thumbnail is uploaded before progressing from step 1
    if (step === 1) {
      if (!stepperFormdata?.bundle_thumbnails ||
        stepperFormdata.bundle_thumbnails.length === 0) {
        setFieldErrors((prev) => ({
          ...prev,
          thumbnails: "At least one thumbnail is required",
        }));
        return;
      } else {
        setFieldErrors((prev) => {
          const copy = { ...prev };
          delete copy.thumbnails;
          return copy;
        });
      }
    }

    if (step === 2) {
      if (!stepperFormdata?.listing_ids || stepperFormdata.listing_ids.length < 2) {
        setFieldErrors((prev) => ({
          ...prev,
          listings: "A bundle must include at least 2 listings",
        }));
        toast.error("A bundle must include at least 2 listings");
        return;
      }
      setFieldErrors((prev) => {
        const copy = { ...prev };
        delete copy.listings;
        return copy;
      });
      handelSubmit();
    } else {
      setStep(step + 1);
    }
  };
  const prevStep = () => {
    setStep(step === 1 ? step : step - 1);
  };
  const location = useLocation();
  const { from } = location?.state || {};

  const handelSubmit = async (e) => {
    if (e) e.preventDefault();
    // Ensure at least one thumbnail exists before submitting
    if (!stepperFormdata?.bundle_thumbnails ||
      stepperFormdata.bundle_thumbnails.length === 0) {
      setFieldErrors((prev) => ({
        ...prev,
        thumbnails: "At least one thumbnail is required",
      }));
      return;
    }
    if (!stepperFormdata?.listing_ids || stepperFormdata.listing_ids.length < 2) {
      setFieldErrors((prev) => ({
        ...prev,
        listings: "A bundle must include at least 2 listings",
      }));
      toast.error("A bundle must include at least 2 listings");
      return;
    }
    // let currentSchema1 = createPaidValidationSchema();
    // const { success, validationErrors } = runValidations(
    //   currentSchema1,
    //   stepperFormdata
    // );
    // if (!success) {
    //   return setFieldErrors(validationErrors);
    // }

    const uploaddata = new FormData();

    uploaddata.append("long_description", stepperFormdata?.long_description);
    uploaddata.append("price", stepperFormdata.price);

    uploaddata.append("short_description", stepperFormdata?.short_description);
    uploaddata.append("title", stepperFormdata?.title);
    uploaddata.append("is_published", stepperFormdata?.is_published);

    if (stepperFormdata?.subcategory) {
      uploaddata.append("subcategory", stepperFormdata?.subcategory);
    }
    if (stepperFormdata?.subsubcategory) {
      uploaddata.append("subsubcategory", stepperFormdata?.subsubcategory);
    }
    if (stepperFormdata?.category) {
      uploaddata.append("category", stepperFormdata?.category);
    }
    stepperFormdata.listing_ids.forEach((id) => {
      uploaddata.append("listing_ids", id);
    });

    stepperFormdata?.bundle_thumbnails.forEach((file) => {
      if (!file?.image) {
        uploaddata.append("thumbnails", file);
      }
    });

    try {
      setloader(true);
      let result;
      if (mocko_id) {
        result = await apiClient.patch(
          `/bundle-listings/${mocko_id}/`,
          uploaddata
        );
      } else {
        result = await apiClient.post("/bundle-listings/", uploaddata);
      }

      setloader(false);
      if (!result.ok) return handleErrors(result.data);
      fetchBundleMockups();
      onHide();
      if (mocko_id) {
        toast.success("Bundle updated successfully!");
      } else {
        toast.success("Bundle added successfully!");
      }
    } catch (error) {
      console.error(error);
      if (mocko_id) {
        toast.error("Error occurred while updating bundle");
      } else {
        toast.error("Error occurred while adding bundle");
      }
    }
  };

  const skipStep = () => {
    setStep(step + 1);
  };
  useEffect(() => {
    if (editlistdata) {
      let listing_ids;
      if (editlistdata?.listings?.length) {
        listing_ids = editlistdata?.listings?.map((item) => item.id);
      }
      const formattedData = {
        ...editlistdata,
        listing_ids,
      };

      setStepperFormdata(formattedData);
    }
  }, [editlistdata]);

  return (
    <div className="container-fluid " style={{ backgroundColor: "#FDFAF1" }}>
      <Loader loading={loader} />
      <div
        className="container d-flex align-items-center justify-content-center px-sm-2 px-0"
        style={{
          minHeight: "auto",
          backgroundColor: "#FDFAF1",
          paddingTop: "80px",
          paddingBottom: "80px",
        }}
      >
        <div
          className="w-100 rounded-5"
          style={{
            backgroundColor: "#FDFAF1",
            minHeight: "auto",
            marginBottom: "0px",
          }}
        >
          <div className="p-2">
            {step === 1 && (
              <Step1
                fieldErrors={fieldErrors}
                stepperFormdata={stepperFormdata}
                handleChange={handleChange}
                setCanvas={setCanvas}
                canvas={canvas}
                setStepperFormdata={setStepperFormdata}
                setFieldErrors={setFieldErrors}
                step={step}
                nextStep={nextStep}
              />
            )}

            {step === 2 && (
              <Step4
                fieldErrors={fieldErrors}
                setFieldErrors={setFieldErrors}
                stepperFormdata={stepperFormdata}
                handleChange={handleChange}
                setStepperFormdata={setStepperFormdata}
                minimumPrice={minimumPrice}
                FeaturedMockups={FeaturedMockups}
              />
            )}
          </div>
          {step === 2 && (
            <div className="d-flex gap-3 justify-content-end pe-4">
              <Button
                onClick={() => prevStep()}
                style={{
                  backgroundColor: "rgb(50,120,228)",
                  color: "white",
                  padding: "12px 26px",
                  fontSize: "15px",
                  width: "170px",
                  border: "none",
                  marginRight: "10px",
                }}
                className="grey-btn"
              >
                Previous
              </Button>
              <Button
                onClick={() => nextStep()}
                style={{
                  backgroundColor: "rgb(50,120,228)",
                  color: "white",
                  padding: "12px 26px",
                  fontSize: "15px",
                  width: "170px",
                  border: "none",
                }}
                className="red-btn"
              >
                Publish
              </Button>
              <Button
                onClick={() => {
                  stepperFormdata.is_published = false;
                  nextStep();
                }}
                style={{
                  backgroundColor: "rgb(50,120,228)",
                  color: "white",
                  padding: "12px 26px",
                  fontSize: "15px",
                  width: "170px",
                  border: "none",
                }}
                className="red-btn"
              >
                Save Unpublished
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Step1 = ({
  setCanvas,
  canvas,
  handleChange,
  stepperFormdata,
  fieldErrors,
  setStepperFormdata,
  setFieldErrors,
  step,
  nextStep,
}) => {
  const [previewimg, setpreviewimg] = useState("");
  const [loading, setLoading] = useState(false);
  const infoIconPath = "../assets/images/info-button.png";

  const infoIconStyle = {
    width: "14px",
    height: "14px",
    cursor: "help",
    margin: "4px 8px 0 0",
    filter: "opacity(0.7)",
  };

  const inputContainerStyle = {
    width: "calc(100% - 22px)",
    flexGrow: 1,
  };

  const formGroupStyle = {
    display: "flex",
    alignItems: "flex-start",
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .form-control {
        border: 2px solid #DBD9D4;
        border-radius: 0.8rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        padding: 0.5rem 1rem;
        height: 48px;
        line-height: 1.5;
      }

      textarea.form-control {
        height: auto;
        padding: 0.75rem 1rem;
        resize: none;
      }

      .form-control:focus {
        border-color: #0081F1;
        box-shadow: 0 0 0 0.2rem rgba(0, 129, 241, 0.25);
      }

      .form-control.is-invalid {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
      }

      .upload-area {
        border: 2px solid #DBD9D4;
        border-radius: 0.8rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        overflow: hidden;
        margin-bottom: 0;
        padding: 0;
      }

      .upload-area.is-invalid {
        border: 2px solid #dc3545;
        border-radius: 0.8rem;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
      }

      label.form-upload-label {
        display: block;
        padding: 0.75rem 1rem;
        margin: 0;
        height: 48px;
        line-height: 1.5;
        border-radius: 0.8rem;
        border: 2px solid #DBD9D4;
        background-color: #FFFFFF;
        cursor: pointer;
        transition: all 0.15s ease-in-out;
      }

      label.form-upload-label:hover {
        background-color: #F8F9FA;
      }

      label.form-upload-label.disabled {
        background-color: #E0E0E0;
        cursor: not-allowed;
      }

      .info-icon-container {
        position: relative;
        display: inline-block;
      }
      .info-tooltip {
        visibility: hidden;
        position: fixed;
        left: 120px;
        z-index: 1000;
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
        background: transparent;
        pointer-events: none;
      }
      .info-tooltip img {
        max-width: min(510px, calc(100vw - 60px)) !important;
        height: auto !important;
        display: block !important;
        filter: drop-shadow(0 4px 40px rgba(0,0,0,0.8)) !important;
        border-radius: 12px !important;
        opacity: 0;
        transform: scale(0.95);
        transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
      }
      /* Title tooltip positioning */
      .info-tooltip img[alt="Title help"] {
        position: fixed;
        top: 10px;
        margin: 0;
      }
      /* Short description tooltip positioning */
      .info-tooltip img[alt="Short description help"] {
        position: fixed;
        top: 50vh;
        transform: translate3d(0, -50%, 0) scale(0.95);
        transform-origin: left center;
        will-change: transform;
      }
      .info-icon-container:hover .info-tooltip img[alt="Short description help"] {
        transform: translate3d(0, -50%, 0) scale(1);
      }
      /* Long description tooltip positioning */
      .info-tooltip img[alt="Long description help"] {
        position: fixed;
        top: 50vh;
        transform: translate3d(0, -50%, 0) scale(0.95);
        transform-origin: left center;
        max-width: min(800px, calc((100vw - 60px) * 0.84)) !important;
        will-change: transform;
      }
      .info-icon-container:hover .info-tooltip img[alt="Long description help"] {
        transform: translate3d(0, -50%, 0) scale(1);
      }
      /* Thumbnails tooltip positioning */
      .info-tooltip img[alt="Thumbnails help"] {
        position: fixed;
        bottom: 50px;
      }
      .info-icon-container:hover .info-tooltip {
        visibility: visible;
        opacity: 1;
        pointer-events: none;
      }
      .info-icon-container:hover .info-tooltip img {
        opacity: 1;
        transform: scale(1);
      }
      /* Mobile adjustments */
      @media screen and (max-width: 768px) {
        .info-tooltip {
          left: 32px;
          right: 32px;
          padding: 16px;
          background-color: rgba(0, 0, 0, 0.75);
          border-radius: 12px;
        }
        .info-tooltip img {
          max-width: calc(100vw - 32px) !important;
          margin: 0 !important;
          transform: none !important;
        }
      }
      /* Improve performance */
      @media (prefers-reduced-motion: reduce) {
        .info-tooltip,
        .info-tooltip img {
          transition: none;
        }
      }

      .form-control.is-invalid {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
      }

      .upload-area.is-invalid {
        border: 2px solid #dc3545 !important;
        border-radius: 0.8rem !important;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    const newCanvas = new fabric.Canvas("canvas", {
      width: 270,
      height: 420,
    });

    setCanvas(newCanvas);
  }, []);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);

    setStepperFormdata((prevData) => {
      const currentFiles = prevData.bundle_thumbnails || [];
      const maxFiles = 4;
      const combinedFiles = [...currentFiles, ...selectedFiles].slice(
        0,
        maxFiles
      );

      return {
        ...prevData,
        bundle_thumbnails: combinedFiles,
      };
    });

    // Clear thumbnail validation error when user adds files
    if (setFieldErrors) {
      setFieldErrors((prev) => {
        const copy = { ...prev };
        delete copy.thumbnails;
        return copy;
      });
    }

    event.target.value = null;
  };

  const isUploadDisabled = stepperFormdata?.bundle_thumbnails?.length >= 4;

  const handleDeleteFile = (index) => {
    const newThumbs = (stepperFormdata?.bundle_thumbnails || []).filter(
      (_, i) => i !== index
    );

    setStepperFormdata((prevData) => ({
      ...prevData,
      bundle_thumbnails: newThumbs,
    }));

    // If no thumbnails remain, set validation error; otherwise clear it
    if (setFieldErrors) {
      if (!newThumbs || newThumbs.length === 0) {
        setFieldErrors((prev) => ({
          ...prev,
          thumbnails: "At least one thumbnail is required",
        }));
      } else {
        setFieldErrors((prev) => {
          const copy = { ...prev };
          delete copy.thumbnails;
          return copy;
        });
      }
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(stepperFormdata.bundle_thumbnails || []);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setStepperFormdata((prev) => ({
      ...prev,
      bundle_thumbnails: items,
    }));
  };

  const [thumbnailUrls, setThumbnailUrls] = useState({});

  useEffect(() => {
    const newUrls = {};

    stepperFormdata?.bundle_thumbnails?.forEach((fileOrUrl, index) => {
      // Case 1: Already a backend URL (string), skip
      if (typeof fileOrUrl === "string") return fileOrUrl?.image;

      // Case 2: If it's a File and no existing preview URL, create one
      if (!thumbnailUrls[index] && fileOrUrl instanceof File) {
        newUrls[index] = URL.createObjectURL(fileOrUrl);
      }
    });

    // Cleanup any old URLs that no longer have a matching file
    Object.entries(thumbnailUrls).forEach(([index, url]) => {
      const thumb = stepperFormdata?.bundle_thumbnails?.[index];
      if (!thumb || typeof thumb === "string") {
        URL.revokeObjectURL(url);
      }
    });

    // Update the state with newly created preview URLs
    if (Object.keys(newUrls).length > 0) {
      setThumbnailUrls((prev) => ({ ...prev, ...newUrls }));
    }

    return () => {
      Object.values(thumbnailUrls).forEach(URL.revokeObjectURL);
    };
  }, [stepperFormdata?.bundle_thumbnails]);

  const ThumbnailPlaceholder = memo(
    ({ index, file, onDelete, provided, snapshot }) => {
      const [objectUrl, setObjectUrl] = useState(null);
      useEffect(() => {
        if (file instanceof File) {
          const url = URL.createObjectURL(file);
          setObjectUrl(url);
          return () => URL.revokeObjectURL(url);
        } else if (typeof file?.image === "string") {
          setObjectUrl(file?.image); // Directly use the string as URL
        }
      }, [file]);

      return (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className="thumbnail-placeholder"
          title={index === 0 ? "This will be your default thumbnail" : ""}
          style={{
            width: "100px",
            height: "100px",
            position: "relative",
            borderRadius: "0.5rem",
            border: index === 0 ? "3px dotted #000000" : "2px dashed #DBD9D4",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: file ? "transparent" : "#F8F9FA",
            transform: snapshot.isDragging ? "scale(1.05)" : "none",
            transition: "transform 0.2s cubic-bezier(0.2, 0, 0, 1)",
            willChange: "transform",
            ...provided.draggableProps.style,
          }}
        >
          {file ? (
            <>
              <button
                className="delete-button"
                onClick={() => onDelete(index)}
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  zIndex: 2,
                  padding: 0,
                  width: "20px",
                  height: "20px",
                  border: "none",
                  borderRadius: "50%",
                  backgroundColor: "black",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Close sx={{ color: "white", fontSize: "14px" }} />
              </button>
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                src={objectUrl}
                alt={`Thumbnail ${index + 1}`}
              />
            </>
          ) : (
            <span style={{ color: "#ADB5BD", fontSize: "14px" }}>
              {index + 1}
            </span>
          )}
        </div>
      );
    }
  );

  return (
    <>
      <div className="">
        <div className="row">
          <div className="mb-3 mb-lg-0" style={{ fontFamily: "Helvetica" }}>
            <div style={formGroupStyle} className="mb-3">
              <div className="info-icon-container">
                <img src={infoIconPath} alt="Info" style={infoIconStyle} />
                <div className="info-tooltip">
                  <img src="../assets/images/title.png" alt="Title help" />
                </div>
              </div>
              <div style={inputContainerStyle}>
                <input
                  type="text"
                  onChange={(e) => handleChange("title", e.target.value)}
                  value={stepperFormdata?.title}
                  className={`form-control rounded-4 ${fieldErrors?.title ? "is-invalid" : ""
                    }`}
                  style={{ height: "48px" }}
                  placeholder="Title"
                  id="title"
                  maxLength={25}
                />
                <small className="text-muted text-end d-block">
                  {stepperFormdata?.title?.length || 0} / 25
                </small>
              </div>
            </div>

            <div style={formGroupStyle} className="mb-3">
              <div className="info-icon-container">
                <img src={infoIconPath} alt="Info" style={infoIconStyle} />
                <div className="info-tooltip">
                  <img
                    src="../assets/images/short-description.png"
                    alt="Short description help"
                  />
                </div>
              </div>
              <div style={inputContainerStyle}>
                <textarea
                  onChange={(e) =>
                    handleChange("short_description", e.target.value)
                  }
                  value={stepperFormdata?.short_description}
                  className={`form-control rounded-4 ${fieldErrors?.short_description ? "is-invalid" : ""
                    }`}
                  id="description"
                  placeholder="Short Description"
                  rows="3"
                  maxLength={60}
                ></textarea>
                <small className="text-muted text-end d-block">
                  {stepperFormdata?.short_description?.length || 0} / 60
                </small>
              </div>
            </div>

            <div style={formGroupStyle} className="mb-3">
              <div className="info-icon-container">
                <img src={infoIconPath} alt="Info" style={infoIconStyle} />
                <div className="info-tooltip">
                  <img
                    src="../assets/images/long-description.png"
                    alt="Long description help"
                  />
                </div>
              </div>
              <div style={inputContainerStyle}>
                <textarea
                  onChange={(e) =>
                    handleChange("long_description", e.target.value)
                  }
                  value={stepperFormdata?.long_description}
                  className={`form-control rounded-4 ${fieldErrors?.long_description ? "is-invalid" : ""
                    }`}
                  id="description"
                  placeholder="Long Description"
                  rows="5"
                  maxLength={200}
                ></textarea>
                <small className="text-muted text-end d-block">
                  {stepperFormdata?.long_description?.length || 0} / 200
                </small>
              </div>
            </div>

            <div style={formGroupStyle} className="mb-3">
              <div className="info-icon-container">
                <img src={infoIconPath} alt="Info" style={infoIconStyle} />
                <div className="info-tooltip">
                  <img
                    src="../assets/images/thumbnails.png"
                    alt="Thumbnails help"
                  />
                </div>
              </div>
              <div
                style={{
                  ...inputContainerStyle,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "100%", marginBottom: "12px" }}>
                  <label
                    style={{
                      backgroundColor: isUploadDisabled ? "#E0E0E0" : "#DBD9D4",
                      cursor: isUploadDisabled ? "not-allowed" : "pointer",
                      border: "2px solid #DBD9D4",
                      borderRadius: "0.8rem",
                      width: "100%",
                      height: "48px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "16px",
                    }}
                    className={`form-control rounded-4 ${fieldErrors?.thumbnails ? "is-invalid" : ""
                      }`}
                    htmlFor="thubmnal"
                  >
                    Upload additional thumbnails (drag to reorder)
                  </label>
                  <input
                    hidden
                    id="thubmnal"
                    type="file"
                    name="thumbnails"
                    accept="image/*"
                    onChange={handleFileChange}
                    disabled={isUploadDisabled}
                    multiple
                  />
                  {fieldErrors?.thumbnails && (
                    <div className="is-invalid d-block text-danger mt-1">
                      {fieldErrors.thumbnails}
                    </div>
                  )}
                </div>
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="thumbnails" direction="horizontal">
                    {(provided) => (
                      <div
                        className="d-flex flex-wrap gap-3 mt-3 justify-content-center"
                        style={{
                          maxWidth: "450px",
                          minHeight: "100px", // Add this to prevent layout shifts
                          touchAction: "none", // Improve touch handling
                        }}
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {[0, 1, 2, 3].map((placeholder, index) => {
                          const file =
                            stepperFormdata?.bundle_thumbnails?.[index];
                          return (
                            <Draggable
                              key={index.toString()}
                              draggableId={index.toString()}
                              index={index}
                              isDragDisabled={!file}
                            >
                              {(provided, snapshot) => (
                                <ThumbnailPlaceholder
                                  index={index}
                                  file={file}
                                  onDelete={handleDeleteFile}
                                  provided={provided}
                                  snapshot={snapshot}
                                />
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>
            <div className="d-flex justify-content-end gap-3 px-4">
              <Button
                onClick={() => nextStep()}
                style={{
                  backgroundColor: "rgb(50,120,228)",
                  color: "white",
                  padding: "12px 26px",
                  fontSize: "15px",
                  width: "170px",
                  border: "none",
                }}
                className="red-btn"
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Step4 = ({
  stepperFormdata,
  handleChange,
  fieldErrors,
  setFieldErrors,
  setStepperFormdata,
  minimumPrice,
  FeaturedMockups,
}) => {
  const [subcategory, setsubCategory] = useState([]);
  const [categories, setcategories] = useState([]);
  const [subSubcategories, setSubSubcategories] = useState([]);
  const [filteredSubSubcategories, setFilteredSubSubcategories] = useState([]);
  const [selectedListings, setSelectedListings] = useState(
    stepperFormdata?.listings
  );
  const [showModal, setShowModal] = useState(false);

  const fetchcategory = async () => {
    const result = await apiClient.get("/categories/");
    if (result.ok) setcategories(result.data.results);
  };
  const fetchsubcategory = async (id) => {
    const result = await apiClient.get(
      `/subcategory/get_by_category/?category=${id}`
    );
    if (result.ok) setsubCategory(result?.data?.subcategories);
  };
  const fetchSubSubcategories = async () => {
    const subsubcategoriesRes = await apiClient.get("/subsubcategories/");
    if (!subsubcategoriesRes.ok)
      throw new Error("Failed to fetch subsubcategories");

    setSubSubcategories(subsubcategoriesRes?.data || []);
    return subsubcategoriesRes?.data?.results;
  };
  const filterSubSubCategories = (subCategoryId) => {
    const filteredSubSubCategories = subSubcategories?.filter(
      (subSubCategory) => subSubCategory?.subcategory === subCategoryId
    );
    setFilteredSubSubcategories(filteredSubSubCategories || []);
  };

  const handleAddListingClick = () => {
    setShowModal(true);
  };

  const allListings = [
    { id: 1, image: "https://via.placeholder.com/100?text=Item+1" },
    { id: 2, image: "https://via.placeholder.com/100?text=Item+2" },
    { id: 3, image: "https://via.placeholder.com/100?text=Item+3" },
    { id: 4, image: "https://via.placeholder.com/100?text=Item+4" },
    // ... add more real listings
  ];

  const handleSelectListing = (listing) => {
    if (!selectedListings.find((l) => l.id === listing.id)) {
      const nextIds = [...(stepperFormdata.listing_ids || []), listing.id];
      stepperFormdata.listing_ids = nextIds;
      setSelectedListings([...selectedListings, listing]);
      if (nextIds.length >= 2 && setFieldErrors) {
        setFieldErrors((prev) => {
          const copy = { ...prev };
          delete copy.listings;
          return copy;
        });
      }
    }
  };
  const handleUnselectListing = (listing) => {
    const updatedListings = selectedListings.filter((l) => l.id !== listing.id);
    setSelectedListings(updatedListings);

    stepperFormdata.listing_ids = stepperFormdata.listing_ids.filter(
      (id) => id !== listing.id
    );
  };

  useEffect(() => {
    fetchcategory();
    fetchSubSubcategories();
    if (stepperFormdata?.category) {
      fetchsubcategory(stepperFormdata?.category);
    }
  }, []);

  useEffect(() => {
    if (stepperFormdata?.subcategory) {
      filterSubSubCategories(stepperFormdata?.subcategory);
    }
  }, [subSubcategories]);

  return (
    <>
      <div className="">
        <h4 className="text-center fw-normal mb-3 ">About this mockup</h4>
        <div className="row mb-3 ">
          <div className="col-md-12 text-start">
            <div className="row mb-3 ">
              <div className="col-md-6 fs-6">
                <p className="fs-6">Set Your Price.</p>
              </div>
              <div className="col-md-6">
                <div className="">
                  <div className="form-group">
                    <input
                      type="text"
                      inputMode="decimal"
                      onChange={(e) => {
                        const next = sanitizeStepperPriceInput(
                          e.target.value,
                        );
                        if (next !== null) {
                          handleChange("price", next);
                        }
                      }}
                      value={stepperFormdata?.price ?? ""}
                      className="form-control rounded-4"
                      style={{ height: "48px", width: "168px" }}
                      placeholder="Price"
                      id="price"
                      autoComplete="off"
                    />
                  </div>
                  <p className=" text-danger text-start fs-6">
                    {" "}
                    {fieldErrors?.price}{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <ListingSelector
                selectedListings={selectedListings}
                onSelectListing={handleSelectListing}
                onUnselectListing={handleUnselectListing}
                maxListings={20}
                minListings={2}
                calledFrom="bundle-stepper"
                setActiveTab={() => { }}
              />
              {fieldErrors?.listings && (
                <p className="text-danger text-start fs-6 mb-0">
                  {fieldErrors.listings}
                </p>
              )}
            </div>
            <div className="row mb-3 ">
              <div className="col-md-6">
                <p className="fs-6">Choose one of our categories </p>
              </div>
              <div className="col-md-6">
                <FormControl
                  sx={{ my: 0.5, width: "100%", borderRadius: "10px" }}
                >
                  <InputLabel id="demo-simple-select-label">
                    {" "}
                    Categories
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Sub Categories"
                    // value={category}
                    onChange={(e) => handleChange("category", e.target.value)}
                    value={stepperFormdata?.category}
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "15px",
                      },
                    }}
                  >
                    {categories?.map((e) => (
                      <MenuItem
                        onClick={() => fetchsubcategory(e?.id)}
                        value={e?.id}
                      >
                        {e?.name}{" "}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl
                  sx={{ my: 0.5, width: "100%", borderRadius: "10px" }}
                >
                  <InputLabel id="demo-simple-select-label" className="fs-6">
                    {" "}
                    SubCategories
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Sub Categories"
                    // value={category}
                    value={stepperFormdata?.subcategory}
                    onChange={(e) => {
                      handleChange("subcategory", e.target.value);

                      filterSubSubCategories(e.target.value);
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "15px",
                      },
                    }}
                  >
                    {subcategory?.map((e) => (
                      <MenuItem value={e?.id}>{e?.name} </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl
                  sx={{ my: 0.5, width: "100%", borderRadius: "10px" }}
                >
                  <InputLabel id="demo-simple-select-label" className="fs-6">
                    {" "}
                    SubSubCategories
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Sub Sub Categories"
                    // value={category}
                    value={stepperFormdata?.subsubcategory}
                    // onChange={(e) =>
                    //   handleChange("subsubcategory", e.target.value)
                    // }
                    onChange={(e) => {
                      handleChange("subsubcategory", e.target.value);
                    }}
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "15px",
                      },
                    }}
                  >
                    {filteredSubSubcategories?.map((e) => (
                      <MenuItem value={e?.id}>{e?.name} </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <p className=" text-danger text-start">
                  {" "}
                  {fieldErrors?.subsubcategory}{" "}
                </p>
              </div>
            </div>

            <div></div>
          </div>
        </div>
      </div>
    </>
  );
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
